import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

import Buttons from "./components/Buttons";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";
import Header from "./components/Header";
import HeaderNavs from "./components/HeaderNavs";
import Share from "./components/Share";
import VideoPlayer from "./components/VideoPlayer";

import DataAppearOnScroll from "./data-attributes/DataAppearOnScroll";
import DataBatch from "./data-attributes/DataBatch";
import DataLink from "./data-attributes/DataLink";
import DataMatchHeight from "./data-attributes/DataMatchHeight";
import DataParallax from "./data-attributes/DataParallax";
import DataTextAppear from "./data-attributes/DataTextAppear";
import EscapeEventListener from "./events/EscapeEventListener";
import AsideForm from "./components/AsideForm";
import {GlobalVariables} from "./GlobalVariables";


export default class StarterKit {
	constructor() {
		console.log("%cFabriqué à Lyon par Digital Cover", "background-color:#211450; color:#FF407D;padding:3px 5px;font-family:monospace;", "https://digital-cover.fr");

		// First
		new SmoothScroll();
		new ResizeEvents();
		new EscapeEventListener();
		new EventListeners();
		new MobileCheck();
		new DevHelpers();

		// Data utils
		new DataAppearOnScroll();
		new DataBatch();
		new DataLink();
		new DataMatchHeight();
		new DataParallax();
		new DataTextAppear();

		// Components
		new AsideForm();
		new Buttons();
		new Gallery();
		GlobalVariables.header = new Header();
		new HeaderNavs();
		new RichText();
		new Share();
		new VideoPlayer();
	}
}
